import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetFilter } from '../selectors/filterSelector'
import DataActions from '../redux/dataRedux'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'
import getFeaturesAtPoint from '../utility/getFeaturesAtPoint'

const id = 'WellsiteRank'
// const datetimeId = 'WellsiteRank'
const datetimeId = 'WellsiteEviControl'
const authId = 'ReclaimedWellsites'
// const sourceLayer = 'WellsiteRank'
// const sourceLayer = 'WellsiteRank2018'
const sourceLayer = 'WellsiteRankAll'
const paintId = 'WellsiteRank'

const paintOutline = {
  'line-opacity': 1,
  'line-width': 4,
  'line-color': [
    'interpolate',
    ['linear'],
    ['number', ['get', 'rank']],
    -2,
    'red',
    -1,
    'orange',
    0,
    'white',
    1,
    'orange',
    2,
    'red'
  ]
}

const datetimeFilterFunction = (date='2017-08-27') => {
  const filter = ['==', 'date', date]

  return filter
}

// const filterFunction = (value = 200, date='2017-08-27') => {
//   const filter = ['all', ['any', ['>', 'rank', (value/100)], ['<', 'rank', -(value/100)]], ['==', 'landtype', 1], ['==', 'date', date]]

//   return filter
// }

const filterFunction = (value = 200, date='2017-08-27') => {
  const filter = ['all', ['any', ['<', 'rank', -(value/100)]], ['==', 'landtype', 1], ['==', 'date', date]]

  return filter
}

// const URL = ({ timeIso }) => `https://coresight-vector.s3-us-west-2.amazonaws.com/WellsiteRank/{z}/{x}/{y}`
// const URL = ({ timeIso }) => `https://coresight-vector.s3-us-west-2.amazonaws.com/WellsiteRank2018/{z}/{x}/{y}`
const URL = ({ timeIso }) => `https://coresight-vector.s3-us-west-2.amazonaws.com/WellsiteRankAll/{z}/{x}/{y}`

export class LeakDetection extends Component {
  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('mousemove', id, this.handleMouseMove)
    map.on('click', id, this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('mousemove', id, this.handleMouseMove)
    map.off('click', id, this.handleClick)
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    // console.log('mousMove')
    if (!layerRendered) {
      return null
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    const data = features.map(feature => feature.properties)
    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }
  }

  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    // console.log('mouse over', layerRendered)
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context
    const { actions } = this.props

    map.getCanvas().style.cursor = ''

    map.getCanvas().style.cursor = ''
    actions.dataUpdated({}, 'hover')
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    const { lng, lat } = event.lngLat
    if (!layerRendered) {
      return
    }
    // const { features } = event
    const features = map.queryRenderedFeatures(event.point)
    if (!features.length) {
      return
    }
    if (features.length > 0) {
      // console.log(features.map(feature => feature.properties.wellsite_f))
      // console.log(features.map(feature => feature))
      // actions.pointDataUpdated(features)
    }
    const sourceFeatures = map.querySourceFeatures(id, {
      sourceLayer: id
    })
    // const id = features[0].properties.wellsite_f
    // const idKey = 'wellsite_f'
    // console.log(lng, lat)
    const featuresAtPoint = getFeaturesAtPoint({ features: sourceFeatures, lng, lat})
    if (featuresAtPoint.length > 0) {
      // console.log('featuresAtPoint')
      // console.log(featuresAtPoint)
      actions.pointDataUpdated(featuresAtPoint)
     }
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.filter !== this.props.filter) {
      return false
    } else if (nextProps.time !== this.props.time) {
      return false
    } else if (nextProps.datetime !== this.props.datetime) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, filter, time, datetime } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        // map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      !isEqual(props.datetime, datetime)
    ) {
      map.getLayer(id) && map.setFilter(id, datetimeFilterFunction(datetime))
      map.getLayer(`${id}Outline`) && map.setFilter(`${id}Outline`, filterFunction(filter, datetime))
    }

    if (
      !isEqual(props.filter, filter)
    ) {
      map.getLayer(`${id}Outline`) && map.setFilter(`${id}Outline`, filterFunction(filter, datetime))
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time, datetime } = this.props
   const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    const vectorSource = {
      type: 'vector',
      tiles: [URL({ idToken, timeIso: time })],
      tileSize: 512,
      minZoom: 13,
      maxZoom: 22
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='fill'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
          filter={datetimeFilterFunction()}
             />
        <Layer
          type='line'
          id={`${id}Outline`}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paintOutline}
          filter={filterFunction()}
          />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getFilter = makeGetFilter()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, paintId),
      time: state.layer.times[datetimeId || id] || undefined,
      datetime: getDatetime(state, datetimeId || id, getDateFromTimeIso) || '2017-08-27',
      filter: getFilter(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      pointDataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, `${id}Point`, event))
    }
  }
}


export default connect(makeMapStateToProps, mapDispatchToProps)(LeakDetection)



// WEBPACK FOOTER //
// ./src/layers/WellsiteRank.js